const experienceData = [
    {
        headline: 'Software Engineer at Tackle',
        dates: '',
        bullets: [
            "Collaborated to create Azure Auto-Create feature, integrating with Azure’s API enabling ISVs to create marketplace offers within Tackle",
            "Contributed to the formation and upkeep of Tackle’s Documentation Guild",
            "Used Motivosity and praise to encourage a culture of documentation",
            "Frequently monitored developer documentation, updating or delegating when necessary, resulting in up-to-date and relevant information",
            "Used 20% of my time to continue learning topics such as Golang, technical writing, software architecture, and presentation skills"
        ]
    },
    {
        headline: 'Software Engineer II at Sharpen',
        dates: 'Aug. 2020 - Sept. 2021',
        bullets: [
            'Created NodeJS microservices to systematically replace functionality in the existing PHP codebase',
            'Learned the basics of DevOps (continuous integration techniques), and SRE (site reliability engineer) responsibilities'
        ]
    },
    {
        headline: 'Team Lead at Lambda School',
        dates: 'Nov. 2019 - Aug. 2020',
        bullets: [
            'Led a team of 9 students that emulates a real work environment using Agile methodology',
            'Reviewed student code to provide daily feedback and one-on-one code reviews',
            'Troubleshooting of web curriculum through slack help channel or code review',
            'Progressively delivered supplemental lectures on various topics related to software engineering',
        ]
    },
]
export default experienceData